import CreateLineRefsCommand from "./CreateLineRefsCommand";
import LineRefsEditing from "./LineRefsEditing";
import LineRefsUI from "./LineRefsUI";

import "./lineRefs.css";

import { Plugin } from "@ckeditor/ckeditor5-core";

export default class LineRefs extends Plugin {
  init() {
    const editor = this.editor;
  }

  static get pluginName() {
    return "LineRefs";
  }

  static get requires() {
    return [CreateLineRefsCommand, LineRefsEditing, LineRefsUI];
  }
}
